import {LicenseType} from 'src/openapi/admin/models/LicenseType';

import type {TreeStructure} from '@pb/kit-component-tree-v2';
import type {LicenseFeatureModule} from 'src/openapi/admin/models/LicenseFeatureModule';

export const hasConcurrentUserCount = (licenseType: LicenseType, seats?: number) => {
    if (Number.isNaN(seats)) {
        return false;
    }
    return licenseType === LicenseType.CU;
};

export const licenseFeatureModuleToTreeStructure =
    (data: Array<LicenseFeatureModule & {explainMaxWidth?: number}>, isDisabled?: boolean): TreeStructure => {
        return data.map(({code, description, disabled, explain, explainMaxWidth}) => ({
            id: code,
            caption: description,
            disabled: isDisabled || disabled,
            explain,
            explainMaxWidth,
        }));
    };
